import { BehaviorSubject, combineLatest } from 'rxjs';
import { ChangeState } from './change-state/change-state';
import { LoadState } from './load-state/load-state';
import { MmChangeableModel } from './mm-changeable.model';
import { SyncState } from './sync-state/sync-state';
import { SyncStatusEnum } from './sync-state/sync-status.enum';

export class MmSyncableModel<T> extends MmChangeableModel<T> {


  private _syncState = new BehaviorSubject<SyncState>(new SyncState({status: SyncStatusEnum.NotSync}));
  public syncState$ = this._syncState.asObservable();

  protected syncableModelStateChange$= combineLatest(
    this.loadState$,
    this.changeState$,
    this.syncState$
  )

  //syncState: SyncState;

  constructor(init?: Partial<MmSyncableModel<T>>) {
    super(init);
    if (init && init.syncState) {
      this.syncState = new SyncState(init.syncState);
    }

    this.intiSubscription();
  }


  protected intiSubscription() {
    if (this.syncableModelStateChange$) {
      this.syncableModelStateChange$.subscribe(([l,c,s])=> { this.generateSyncableModelData(l,c,s)})
    }
  }


  private generateSyncableModelData(loadState: LoadState<T>, changeState: ChangeState<T>, syncState: SyncState) {
    const data: T = {} as T;

    if (loadState?.data) {
      Object.assign(data, loadState?.data);
    }
    if (syncState?.changes) {
      syncState.changes.forEach(c => Object.assign(data, c.data ));
    }
    if (changeState?.data) {
      Object.assign(data, changeState?.data);
    }
    this.uid = this.uid ?? (data as any).UniqueId;
    this.setData(data);
  }

  get syncState(): SyncState {
    return this._syncState.value;
  }

  set syncState(v: SyncState) {
    this._syncState.next(v);
  }


}
